import { Component, h, Prop, Host } from "@stencil/core";
import { PopoverPlacementType } from "../popover/interface";

/**
 * @slot (default) - The panel content
 */
@Component({
    tag: "ux-popover-panel",
    styleUrl: "./popover-panel.scss",
})
export class PopoverPanel {
    /** Placement of the popover relative to the target element*/
    @Prop() placement: PopoverPlacementType | null = null;
    /** Whether or not to display an arrow */
    @Prop() arrow: boolean = true;
    /** Style variant of the panel */
    @Prop() variant: "default" | "primary" | "secondary" = "default";
    render() {
        return (
            <Host
                class={{
                    [`ux-popover-panel`]: true,
                    [`ux-popover-panel--${this.variant}`]:
                        this.variant && this.variant !== "default",
                    [`ux-popover-panel--arrow`]:
                        this.arrow && this.placement !== null,
                }}
                data-popover-placement={this.placement}
            >
                {this.arrow && <ux-popover-panel-arrow />}
                <div class="ux-popover-panel__inner">
                    <slot />
                </div>
            </Host>
        );
    }
}
